import { cardsData } from '@/mocks/home-data';

const cardImages = [
  'https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20editorial%20image%20with%20warm%20crimson%20tones%2C%20abstract%20stage%20performance%20scene%2C%20spotlight%20effect%2C%20magazine%20photography%20style%2C%20soft%20shadows%2C%20professional%20composition&width=800&height=500&seq=card-img-1-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20cinematic%20film%20set%20scene%20with%20warm%20golden%20lighting%2C%20abstract%20camera%20and%20equipment%20silhouettes%2C%20dramatic%20atmosphere%2C%20movie%20production%20aesthetic%2C%20rich%20amber%20tones%2C%20editorial%20style&width=800&height=500&seq=card-img-2-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20abstract%20idol%20group%20performance%20scene%20with%20warm%20stage%20lighting%2C%20concert%20atmosphere%2C%20dramatic%20spotlights%2C%20entertainment%20industry%20aesthetic%2C%20soft%20focus%2C%20editorial%20photography&width=800&height=500&seq=card-img-3-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20music%20studio%20scene%20with%20warm%20amber%20lighting%2C%20abstract%20sheet%20music%20and%20instruments%2C%20creative%20atmosphere%2C%20artistic%20composition%2C%20soft%20shadows%2C%20editorial%20style%2C%20rich%20textures&width=800&height=500&seq=card-img-4-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20warm%20dramatic%20lighting%2C%20abstract%20production%20equipment%2C%20variety%20show%20atmosphere%2C%20entertainment%20industry%20aesthetic%2C%20professional%20composition%2C%20soft%20focus%20background&width=800&height=500&seq=card-img-5-bagua&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            深度追踪
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          热门事件深度解读，还原八卦背后的真相
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={cardImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded text-[10px] font-medium ${
                    item.tag === '独家'
                      ? 'bg-primary-500 text-background-50'
                      : item.tag === '热爆'
                        ? 'bg-accent-500 text-background-50'
                        : item.tag === '新瓜'
                          ? 'bg-secondary-500 text-background-50'
                          : 'bg-background-800 text-background-50'
                  }`}
                >
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-primary-500 font-medium mb-1.5">
                  {item.category}
                </span>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-400 mt-3 font-medium">
                  阅读全文
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}